import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const onspring = defineConnector({
  identifier: "onspring",
  name: "Onspring",
  tagLine: "Governance, risk, and compliance",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.onspring.com"),
  auth: headerAuth([
    { name: "X-ApiKey", value: { from: "secret", field: "apiKey" } },
    { name: "x-api-version", value: { from: "literal", value: "2" } },
  ]),
  steps: [
    {
      title: "Set up Onspring",
      items: [
        {
          kind: "markdown",
          content:
            "Open **Administration → Security → API Keys** in Onspring. Create or select an enabled key, assign a role with the read permissions you need, and copy **Developer Information → X-ApiKey Header**. See [API setup](https://github.com/onspring-technologies/onspring-api-sdk).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.onspring.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText: "Use https://api.onspring.com for the Onspring API.",
        },
        {
          kind: "input",
          label: "Onspring API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "In Onspring, go to Administration → Security → API Keys. Select an existing key or create one if you have Create permission. Open Developer Information and copy the X-ApiKey Header value.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.onspring.com").trim().replace(/\/+$/, "") +
        "/Apps?PageNumber=1&PageSize=1",
      method: "GET",
      headers: { "x-api-version": "2", Accept: "application/json" },
    }),
  },
});
